import LoansCard from "./LoansCard";

const LoansCardContainer = ({ loans, loanYears }: any) => {
  return <LoansCard loans={loans} loanYears={loanYears} />;
};

export default LoansCardContainer;
